/* unplugin-vue-components disabled */import { render } from "./OffBoardingOwner.vue?vue&type=template&id=2892f6e3"
import script from "./OffBoardingOwner.vue?vue&type=script&lang=js"
export * from "./OffBoardingOwner.vue?vue&type=script&lang=js"

import "./OffBoardingOwner.vue?vue&type=style&index=0&id=2892f6e3&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__